import api, { authInstance } from "./index";

/**
 * 인증 관련 API (AUTH_URL 사용)
 */
export const authApi = {
  // 로그인 요청
  login: (email, password) => authInstance.post("/login", { email, password }),

  // 리프레시 토큰으로 토큰 갱신 (자동 로그인용)
  refresh: (refreshToken) =>
    authInstance.post("/refresh", { refresh_token: refreshToken }),

  // 비밀번호 변경
  changePassword: (currentPassword, newPassword) =>
    api.put("/password", {
      current_password: currentPassword,
      new_password: newPassword,
    }),
};

/**
 * 청도지 코드 관련 API
 */
export const wsApi = {
  // 반 정보(ws-codes) 가져오기
  getWsCodes: () => api.get("/ws-codes"),

  // 특정 반의 사용자(참가자) 목록 가져오기
  getWsUsers: () => api.get("/users"),

  // 특정 사용자 상세 정보 조회 (V2 POST)
  getUserDetail: (userId) => api.post("/users/detail", { user_id: userId }),

  // 특정 사용자 만족도 조사 상세 조회
  getUserSatisfactionSurveyDetail: (userId, resultId) =>
    api.post("/users/detail/satisfaction-survey-detail", {
      user_id: userId,
      result_id: resultId,
    }),

  // 사용자에게 설문조사 알림 발송 (V2 POST)
  sendSurveyNotification: (userId, surveyType) =>
    api.post("/users/survey-notification", {
      user_id: userId,
      survey_type: surveyType,
    }),

  //만족도조사 통계
  getSatisfactionSurveyStats: (assessmentId) =>
    api.get(`/assessments/${assessmentId}/stats`),

  // 전체 문의 내역 조회
  getInquiryList: (inquiryStatus, page_size, current_page) => api.get("/support/inquiries", {params: {status: inquiryStatus, page_size: page_size, current_page: current_page}}),

  // 답변현황 PROGRESS 변경
  patchInquiryStatus: (inquiryId) => api.patch("/support/inquiries", null, {params: {inquiry_id: inquiryId}}),

  // 문의 답변 이메일 전송
  sendInquiryReply: (inquiry_id, answer_title, answer_content) => api.post("/support/inquiries/reply", { inquiry_id, answer_title, answer_content }),

  // 문의 답변 조회
  getInquiryAnswer: (inquiry_id) => api.get("/support/inquiries/answer", {params: {inquiry_id: inquiry_id}}),

  // 사이드바
  getSideBar: () => api.get(`/organizations`),

  // 선택한 프로젝트(사업) 코드 기준 참가자 목록 조회
  getUsersByCode: (code) => api.get("/users", { params: { code } }),

  // 선택한 프로젝트(사업) 코드 기준 검사 통계 조회 (참가자 목록과 분리된 별도 API)
  // start_date/end_date 생략 시 서버에서 주별 통계 4주치를 응답
  getProgramStats: (code, startDate, endDate) =>
    api.get("/assessments/program-stats", {
      params: {
        code,
        ...(startDate ? { start_date: startDate } : {}),
        ...(endDate ? { end_date: endDate } : {}),
      },
    }),

  // 프로젝트(사업) 내 특정 참가자 상세 조회 (PHQ-9/GAD-7 회차 이력, 주간 증상·디스트레스 지표)
  // start_date/end_date 생략 시 서버에서 최근 7일(오늘 포함) 기준으로 응답
  getUserProgramDetail: (userId, code, startDate, endDate) =>
    api.post("/users/program-detail", {
      user_id: userId,
      code,
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
    }),

  // 프로젝트(사업) 내 특정 참가자 상세 조회 - 월성복지관 소속 전용 (program-detail과 별도 API)
  getUserWsDetail: (userId, code) =>
    api.post("/users/ws-detail", { user_id: userId, code }),

  // 선택한 프로젝트(사업) 코드 기준 자살/자해 위험 감지 목록 조회
  getSuicideRiskUsers: (code) => api.get("/users/suicide-risk", { params: { code } }),
};
